const BID_PACKAGE_PATH =
  "M22.322 13.0848V11.9062C22.322 11.7982 22.2336 11.7098 22.1256 11.7098H12.697C12.589 11.7098 12.5006 11.7982 12.5006 11.9062V13.0848C12.5006 13.1928 12.589 13.2812 12.697 13.2812H22.1256C22.2336 13.2812 22.322 13.1928 22.322 13.0848ZM12.697 15.2455C12.589 15.2455 12.5006 15.3339 12.5006 15.4419V16.6205C12.5006 16.7286 12.589 16.8169 12.697 16.8169H17.2149C17.3229 16.8169 17.4113 16.7286 17.4113 16.6205V15.4419C17.4113 15.3339 17.3229 15.2455 17.2149 15.2455H12.697ZM21.9291 18.0937C18.9999 18.0937 16.6256 20.4681 16.6256 23.3973C16.6256 26.3265 18.9999 28.7009 21.9291 28.7009C24.8584 28.7009 27.2327 26.3265 27.2327 23.3973C27.2327 20.4681 24.8584 18.0937 21.9291 18.0937ZM24.5687 26.0368C23.864 26.7415 22.926 27.1294 21.9291 27.1294C20.9323 27.1294 19.9943 26.7415 19.2896 26.0368C18.585 25.3321 18.197 24.3942 18.197 23.3973C18.197 22.4004 18.585 21.4625 19.2896 20.7578C19.9943 20.0531 20.9323 19.6652 21.9291 19.6652C22.926 19.6652 23.864 20.0531 24.5687 20.7578C25.2733 21.4625 25.6613 22.4004 25.6613 23.3973C25.6613 24.3942 25.2733 25.3321 24.5687 26.0368ZM24.1144 21.5312H23.0267C22.9629 21.5312 22.9039 21.5607 22.8671 21.6123L21.3079 23.7681L20.7408 22.9848C20.7226 22.9595 20.6986 22.9389 20.6708 22.9248C20.6431 22.9107 20.6123 22.9035 20.5812 22.9038H19.4983C19.3387 22.9038 19.2454 23.0855 19.3387 23.2156L21.1508 25.7225C21.2294 25.8306 21.389 25.8306 21.4675 25.7225L24.2716 21.8431C24.3673 21.7129 24.274 21.5312 24.1144 21.5312ZM16.2327 26.3437H10.5363V9.05802H24.2863V17.5044C24.2863 17.6125 24.3747 17.7009 24.4827 17.7009H25.8577C25.9658 17.7009 26.0541 17.6125 26.0541 17.5044V8.07588C26.0541 7.64128 25.703 7.29016 25.2684 7.29016H9.55415C9.11955 7.29016 8.76843 7.64128 8.76843 8.07588V27.3259C8.76843 27.7605 9.11955 28.1116 9.55415 28.1116H16.2327C16.3408 28.1116 16.4291 28.0232 16.4291 27.9152V26.5402C16.4291 26.4321 16.3408 26.3437 16.2327 26.3437Z";

/**
 * Bid Package glyph — document with a check mark, no tile. A filled shape, so
 * the colour comes from a `fill-*` class in `className`.
 */
export default function BidPackageCiqIcon({
  size = 12,
  className = "fill-black",
  opacity = "0.6"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="7.3 7.3 21.4 21.4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d={BID_PACKAGE_PATH} fillOpacity={opacity} />
    </svg>
  );
}

/**
 * Bid Package badge — the same glyph on its fixed-colour tile.
 * Design: 36×36 container (#FFB64F) + glyph (#B85C16). Used by CiqIconBox.
 */
export function BidPackageTileCiqIcon({
  size = 36,
  className = ""
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="36" height="36" rx="4" fill="#FFB64F" />
      <path d={BID_PACKAGE_PATH} fill="#B85C16" />
    </svg>
  );
}
